var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIconSplitRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 72,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrowIconSplitRight_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 399",
    transform: "translate(269 48)",
    fill: "#fff",
    stroke: "#707070",
    d: "M0 0h140v72H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "arrowIconSplitRight_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 398",
    fill: "none",
    d: "M0 0h140v72H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-269 -48)",
    clipPath: "url(#arrowIconSplitRight_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(269 48)",
    clipPath: "url(#arrowIconSplitRight_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 315",
    fill: "#040000"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 334",
    d: "M139.594 34.911L111.048.616a1.7 1.7 0 00-3.011 1.09v68.588a1.7 1.7 0 003.011 1.089l28.546-34.294a1.7 1.7 0 000-2.178"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 335",
    d: "M1.246 21A1.129 1.129 0 000 21.948v28.1A1.129 1.129 0 001.246 51H7.46V21z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 396",
    d: "M26.867 21h82.37v30h-82.37z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 397",
    d: "M12.227 21h9.872v30h-9.872z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIconSplitRight);
export default __webpack_public_path__ + "static/media/arrowIconSplitRight.e09e899fe4db3bff.svg";
export { ForwardRef as ReactComponent };